import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { MenuItem } from '@/shared/components/ui/menu-item/menu-item';
import { TruncatedText } from '@/shared/components/ui/truncated-text/truncated-text';
import { TAddTagMenuItemProps } from '@/shared/features/tags/components/tag-select/add-tag-menu-item.types';
import { useCreateTagMutation } from '@/shared/redux/api/assets/tags/tags-api';
import { showToastError } from '@/shared/utils/toast';

export const AddTagMenuItem: React.FC<TAddTagMenuItemProps> = ({
  name,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const [createTag, { isLoading }] = useCreateTagMutation();

  const onClick = async () => {
    try {
      await createTag({ tag: { name } }).unwrap();
      onSuccess?.(name);
      toast.success(t('tags:tag_select.tag_create_success'));
    } catch {
      showToastError(t('tags:tag_select.tag_create_error'));
    }
  };

  return (
    <MenuItem disabled={isLoading} onClick={onClick}>
      <Typography color="textSecondary" variant="p8">
        {t('tags:tag_select.add_tag.part_1')}
      </Typography>
      <Box>
        "<TruncatedText color="textPrimary" variant="p8" text={name} />"
      </Box>
      <Typography color="textSecondary" variant="p8">
        {t('tags:tag_select.add_tag.part_3')}
      </Typography>
    </MenuItem>
  );
};
